import { useMutation } from '@tanstack/react-query';
import { api } from '@shared/api/client';
import { COMMERCE } from '@shared/api/endpoints';
import type { JobInitiateResponse } from '@tailorcast/shared-types';

export function useTriggerReviewAnalysis() {
  return useMutation({
    mutationFn: () =>
      api.post<JobInitiateResponse>(COMMERCE.REVIEWS_START, { marketplace: 'bitrix' }),
  });
}
